var BaseView = require('./baseView');


/**
 * Here currently implies the shape level view in the results.
 * Currently no dropdown at the note level, just in the top search model.
 * Opening and closing via the dropdown plugin vs open/destroy,
 */

module.exports = BaseView.extend({

    dialogOptions: function() {

        var options = BaseView.prototype.dialogOptions.apply( this, arguments );

        /*  getting around inheritance issues now ... */
        options.onReasonCodeSubViewChange  = _.bind( this.onReasonCodeSubViewChange, this );
        options.selectAllReasonCodes = _.bind( this.selectAllReasonCodes, this );
        options.clearAllReasonCodes = _.bind( this.clearAllReasonCodes, this );

        return options;

    },

    events: _.extend( {}, BaseView.prototype.events, {

        'click': 'stopPropagationOnClick'
    }),

    stopPropagationOnClick: function(e) {

        e.stopPropagation();
    },

    onReasonCodeSubViewChange: function( selectedReasonCodes ) {
        this.channel.trigger( 'findAndRedact:hitShapeReasonCodesChange', this.shape, selectedReasonCodes );

    },

    selectAllReasonCodes: function() {

        var codes = this.redactionZonePropertiesRegion.currentView._getReasonCodeModelsForSelectAll();
        this.channel.trigger( 'findAndRedact:hitShapeReasonCodesChange', this.shape, codes, 1 );

    },

    clearAllReasonCodes: function() {
        this.channel.trigger( 'findAndRedact:hitShapeReasonCodesChange', this.shape, null, 1 );

    },

    /**
     *  Proxy from the dialog close when view used as it's content ( hack -- when called as dialog ).
     *  Unlike the top level search, we do need to tell if the reason codes and fill changed --
     *  these are all new and the properties are set from local storage.
     *  Need to update for next dialog open
     */
    onDialogClose: function() {

        this.shape.updateLocalStoragePostDialogClose( 1 );

    }


});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/findAndRedact/layout/notePropertyViews/shapeProperties/redaction/shapeLevelView.js
 ** module id = 608
 ** module chunks = 0
 **/